<template>
    <div class="pro-form-card">
        <div class="pro-form-header">
            <div class="header-right">
              <v-icon class="primary-color-assuraf mr-2">&#xe531;</v-icon>
                <span class="badge">{{ $t('calcule_puissance_ficale.form_calcule_puissance_ficale.header_right') }}</span>
            </div>
        </div>

        <div class="mt-5">
            <div class="fields">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('calcule_puissance_ficale.form_calcule_puissance_ficale.type_carburant_label') }} <span class="required-asterisk">*</span></label>
                            <select v-model="carburation" class="field-input" :class="{ invalid: !!errors.carburation }">
                                <option value="" disabled selected>Sélectionner</option>
                                <option value="Essence">Essence</option>
                                <option value="Diesel">Diesel</option>
                            </select>
                            <small v-if="errors.carburation" class="error-msg">{{ errors.carburation }}</small>
                        </div>
                    </div>
                     <div class="col-sm-6">
                        <div class="field-group field-default mb-4 mb-sm-0">
                            <label class="field-label">{{ $t('calcule_puissance_ficale.form_calcule_puissance_ficale.cylindree_label') }} <span class="required-asterisk">*</span></label>
                            <input v-model.number="cylindree" type="number" class="field-input" :class="{ invalid: !!errors.cylindree }" :placeholder="$t('calcule_puissance_ficale.form_calcule_puissance_ficale.cylindree_placeholder')">
                            <small v-if="errors.cylindree" class="error-msg">{{ errors.cylindree }}</small>
                        </div>
                    </div>
                </div>
            </div>

            

            <!-- Result Display -->
            <div v-if="result !== null" class="result-box mt-4 mb-4 text-xs-center">
                <h3 class="result-title">{{ $t('calcule_puissance_ficale.result.title') }}</h3>
                <div class="result-value">{{ Math.round(result) }} {{ $t('calcule_puissance_ficale.result.cv_label') }}</div>
            </div>

            <div class="actions">
              
                <button @click="simulate" type="button" class="ml-3 wizard-btn send-btn">
                    <v-progress-circular v-if="isLoading" indeterminate color="#000000de" size="24" class="mr-2"></v-progress-circular>
                    <span>{{ $t('calcule_puissance_ficale.form_calcule_puissance_ficale.simule_button_label') }}</span>
                </button>
            </div>

                        <p class="required pt-3"><span class="required-asterisk">*</span> {{ $t('calcule_puissance_ficale.form_calcule_puissance_ficale.required_field_label') }}</p>

        </div>
    </div>
</template>

<script>
export default {
    name: 'CVFiscalForm',
    data: () => ({
        carburation: '',
        cylindree: '',
        result: null,
        errors: {
            carburation: null,
            cylindree: null
        }
    }),
    methods: {
        simulate() {
            this.errors = { carburation: null, cylindree: null };
            let isValid = true;

            if (!this.carburation) {
                this.errors.carburation = "Veuillez sélectionner le type de carburant.";
                isValid = false;
            }

            if (!this.cylindree || this.cylindree <= 0) {
                this.errors.cylindree = "Veuillez renseigner une cylindrée valide.";
                isValid = false;
            }

            if (!isValid) return;

            const coefficient = this.carburation === 'Essence' ? 5.71 : 4.019;
            const cv = (this.cylindree * coefficient) / 1000;
            this.result = cv.toFixed(2);
        }
    }
}
</script>

<style scoped>
.pro-form-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(13, 78, 120, 0.15);
  padding: 20px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}

.pro-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(13, 78, 120, 0.12);
  margin-bottom: 16px;
}

.header-right {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
}

.fields { margin-bottom: 10px; }
.row { display: flex; flex-wrap: wrap; gap: 12px; }
.col-sm-6 { flex: 1 1 calc(50% - 12px); min-width: 260px; }
.field-group { display: flex; flex-direction: column; }
.field-label { font-size: 13px; font-weight: 600; color: #0d4e78; margin-bottom: 6px; }
.required-asterisk { color: #ff0000; }
.field-input {
  height: 44px;
  border: 1px solid #dfe1e5;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 14px;
  color: #333;
  width: 100%;
  transition: all 0.2s;
  background: #fff;
}
.field-input:focus { border-color: #0d4e78; outline: none; box-shadow: 0 0 0 3px rgba(13, 78, 120, 0.1); }
.field-input.invalid { border-color: #ff5252; }
.error-msg { color: #ff5252; font-size: 12px; margin-top: 4px; }

.actions { display: flex; justify-content: center; margin-top: 20px; }
.wizard-btn {
  height: 48px;
  padding: 0 32px;
  border-radius: 99px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.send-btn { background: #ffa409; color: #fff; }
.send-btn:hover { background: #d88b05; transform: translateY(-1px); }

.result-box {
    background: #f0f7ff;
    border: 1px solid #cce4ff;
    border-radius: 12px;
    padding: 20px;
    margin-top: 20px;
}
.result-title { color: #0d4e78; font-size: 16px; margin-bottom: 8px; }
.result-value { color: #ffa409; font-size: 24px; font-weight: bold; }
</style>
